module.exports = __webpack_public_path__ + "c5e7923762a677d6df8bdc87a6075117.svg";